export const AAA_SERVER_SECTION_EVENT =
	'canvas-agent:aaa-server:section';
export const AAA_SERVER_FILTER_EVENT =
	'canvas-agent:aaa-server:filter';
export const AAA_SERVER_FOCUS_EVENT =
	'canvas-agent:aaa-server:focus';
export const AAA_SERVER_CREATE_MODAL_EVENT =
	'canvas-agent:aaa-server:create-modal';
export const AAA_SERVER_EDIT_MODAL_EVENT =
	'canvas-agent:aaa-server:edit-modal';
export const AAA_SERVER_DELETE_MODAL_EVENT =
	'canvas-agent:aaa-server:delete-modal';
